var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_vm._t("default"),(_vm.loading)?_c('div',{staticClass:"overlay"},[_c('v-progress-circular',{attrs:{"color":"primary","size":"70","width":"7","indeterminate":""}})],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }